/* eslint-disable @typescript-eslint/naming-convention */
import { css } from 'styled-components';
// import {
//   reworkCalendarDay, reworkCalendarDayOutside,
//   reworkCalendarDays,
//   reworkCalendarHeader,
//   reworkDefaults, reworkMonthContainer,
// } from '@widgets/shared/components/CustomDatepicker/styles/rework';
// import {
//   reworkCalendarDayHighlighted,
//   reworkCalendarDayHover,
//   reworkCalendarDayNumber, reworkCalendarDayNumberHighlighted, reworkCalendarDayNumberHover,
//   reworkCalendarDayPriceHover,
// } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles/rework';
const accent = 'var(--primary-darker)';
const accentLight = 'var(--primary-medium)';
const accentAlt = 'var(--primary-light)';
const invertedAccent = '#ffffff';
const border = 'var(--border)';
const numberInputColour = '#00AEEF';
const text = 'var(--text)';
const error = 'var(--error)';
const success = '#0DB14B';
// eslint-disable-next-line max-len
const font = 'var(--body-font)';
const headingFont = 'var(--heading-font)';
const rocFont = 'var(--roc-heading-font)';
const productTheme = {
    accent,
    accentLight,
    invertedAccent,
    numberInputColour,
    border,
    text,
    error,
    success,
    attendeesShowTotals: false,
    showOverviewIcon: false,
    showOverviewTime: false,
    showOverviewDate: false,
    showOverviewAttendees: false,
    submitButton: css `
    margin-top: 1rem !important;
    width: 100%;
    background-color: var(--secondary-btn);
    border-color: var(--secondary-btn);

    &:hover {
      background-color: var(--secondary-btn-hover);
      border-color: var(--secondary-btn-hover);
    }
  `,
    continueButton: css `
    &.btn {
      margin-top: 2.5rem;
      width: 100%;
      background-color: var(--primary-btn);
      border-color: var(--primary-btn);
      
      &:hover {
        background-color: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
      }
      
      &:disabled {
        background-color: var(--disabled-btn);
        border-color: var(--disabled-btn);
        
        &:hover {
          background-color: var(--disabled-btn, $disabled-btn);
          border-color: var(--disabled-btn, $disabled-btn);
        }
      }
    }
  `,
};
export default productTheme;
